@if ({ eiTilikausia: eiTilikausiaObservable | async }; as tila) {
  <div class="list-page" style="max-width: 1200px; margin-bottom: 6em">
    @if (!tila.eiTilikausia) {
      <form>
        <div class="filter-bar">
          <div class="date-chip-group">
            @for (tilikausi of naytettavatTilikaudetObservable | async; track tilikausi) {
              <button class="date-chip" [class.green-chip]="naytettavaTilikausi()?.labelHover !== tilikausi.labelHover && !!tilikausi.lukittu" [title]="tilikausi?.labelHover || null" [class.date-chip-selected]="naytettavaTilikausi()?.labelHover === tilikausi.labelHover" type="button" mat-button (click)="valitseTilikausi(tilikausi)">
                {{ tilikausi?.label }}
              </button>
            }
          </div>
          <div class="form-boxes" style="width: 228px">
            <div class="rounded-input" style="padding: 0 5px 0 8px">
              <input #alkaaInput type="text" [matDatepicker]="alkaaPicker" [formField]="lomake.alkaa" matInput data-lpignore="true" style="width: 70px" />
              <button mat-icon-button (click)="alkaaPicker.open()" style="width: 20px; height: 20px; line-height: 20px">
                <mat-icon style="width: 20px; height: 20px; line-height: 20px; font-size: 16px; top: 0; left: 0; right: 0; bottom: 0; position: absolute">calendar_today</mat-icon>
              </button>
              <!-- <mat-datepicker-toggle matSuffix [for]="alkaaPicker"></mat-datepicker-toggle> -->
              <mat-datepicker #alkaaPicker startView="year"></mat-datepicker>
            </div>
            <div style="margin: 0 5px">-</div>
            <div class="rounded-input" style="padding: 0 5px 0 8px">
              <input type="text" [matDatepicker]="loppuuPicker" [formField]="lomake.loppuu" matInput data-lpignore="true" style="width: 70px" />
              <button mat-icon-button (click)="loppuuPicker.open()" style="width: 20px; height: 20px; line-height: 20px">
                <mat-icon style="width: 20px; height: 20px; line-height: 20px; font-size: 16px; top: 0; left: 0; right: 0; bottom: 0; position: absolute">calendar_today</mat-icon>
              </button>
              <!-- <mat-datepicker-toggle matSuffix [for]="loppuuPicker"></mat-datepicker-toggle> -->
              <mat-datepicker #loppuuPicker startView="year"></mat-datepicker>
            </div>
          </div>
        </div>
        <div class="filter-bar">
          @if (naytettavaTilikausi()) {
            <div class="date-chip-group">
              @for (mm of naytettavaTilikausi().months; track mm) {
                <button class="date-chip" [title]="mm?.numberMonth | numbermonthtomonthyear | async" [class.date-chip-selected]="dateBtnsSelectedMonth() === mm.numberMonth" [class.green-chip]="dateBtnsSelectedMonth() !== mm.numberMonth && kuukausienStatuksetMap()[mm.numberMonth] === 'ok'" type="button" mat-button (click)="valitseKuukausi(mm)">
                  {{ mm?.label }}
                </button>
              }
            </div>
          }
        </div>
      </form>
    }
    <mat-tab-group #tabGroup mat-stretch-tabs animationDuration="0ms" style="margin-top: 2em; overflow: hidden">
      <mat-tab [label]="'raportit.tuloslaskelma' | translate | async">
        @if (!tila.eiTilikausia && selectedTab() === 'tulos') {
          <div class="pdf-btn-row">
            <button mat-button (click)="openPdfSelect()">
              <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512" style="height: 20px; vertical-align: middle">
                <path d="M320 336h76c55 0 100-21.21 100-75.6s-53-73.47-96-75.6C391.11 99.74 329 48 256 48c-69 0-113.44 45.79-128 91.2-60 5.7-112 35.88-112 98.4S70 336 136 336h56M192 400.1l64 63.9 64-63.9M256 224v224.03" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" />
              </svg>
              {{ 'raportit.lataa-pdf' | translate | async }}
            </button>
            <div class="hidden-select">
              <mat-select #pdfSelect>
                @for (pdf of pdfList(); track pdf) {
                  <mat-option (click)="downloadPdf(pdf.type, pdf.kieli)">
                    {{ pdf.tag }}
                  </mat-option>
                }
              </mat-select>
            </div>
            <button mat-button (click)="openCsvSelect()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" style="height: 20px; vertical-align: middle">
                <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm240-240H200v160h240v-160Zm80 0v160h240v-160H520Zm-80-80v-160H200v160h240Zm80 0h240v-160H520v160ZM200-680h560v-80H200v80Z" fill="currentColor" />
              </svg>
              {{ 'raportit.lataa-csv' | translate | async }}
            </button>
            <div class="hidden-select">
              <mat-select #csvSelect>
                @for (csv of csvList(); track csv) {
                  <mat-option (click)="downloadCsv(csv.type, csv.kieli)">
                    {{ csv.tag }}
                  </mat-option>
                }
              </mat-select>
            </div>
          </div>
        }
        @if (!tila.eiTilikausia && selectedTab() === 'tulos') {
          <div app-kirjanpito-tuloslaskelma [hakuvaihtoehdotObservable]="hakuvaihtoehdotObservable" class="raportti-container"></div>
        }
      </mat-tab>
      <mat-tab [label]="'raportit.tase' | translate | async">
        @if (!tila.eiTilikausia && selectedTab() === 'tase') {
          <div class="pdf-btn-row">
            <button mat-button (click)="openPdfSelect()">
              <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512" style="height: 20px; vertical-align: middle">
                <path d="M320 336h76c55 0 100-21.21 100-75.6s-53-73.47-96-75.6C391.11 99.74 329 48 256 48c-69 0-113.44 45.79-128 91.2-60 5.7-112 35.88-112 98.4S70 336 136 336h56M192 400.1l64 63.9 64-63.9M256 224v224.03" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" />
              </svg>
              {{ 'raportit.lataa-pdf' | translate | async }}
            </button>
            <div class="hidden-select">
              <mat-select #pdfSelect>
                @for (pdf of pdfList(); track pdf) {
                  <mat-option (click)="downloadPdf(pdf.type, pdf.kieli)">
                    {{ pdf.tag }}
                  </mat-option>
                }
              </mat-select>
            </div>
            <button mat-button (click)="openCsvSelect()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" style="height: 20px; vertical-align: middle">
                <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm240-240H200v160h240v-160Zm80 0v160h240v-160H520Zm-80-80v-160H200v160h240Zm80 0h240v-160H520v160ZM200-680h560v-80H200v80Z" fill="currentColor" />
              </svg>
              {{ 'raportit.lataa-csv' | translate | async }}
            </button>
            <div class="hidden-select">
              <mat-select #csvSelect>
                @for (csv of csvList(); track csv) {
                  <mat-option (click)="downloadCsv(csv.type, csv.kieli)">
                    {{ csv.tag }}
                  </mat-option>
                }
              </mat-select>
            </div>
          </div>
        }
        @if (!tila.eiTilikausia && selectedTab() === 'tase') {
          <div app-kirjanpito-tase [hakuvaihtoehdotObservable]="hakuvaihtoehdotObservable" class="raportti-container"></div>
        }
      </mat-tab>
      <mat-tab [label]="'raportit.lyhyt-tase-ja-tulos' | translate | async">
        @if (!tila.eiTilikausia && selectedTab() === 'lyhyt-tase-ja-tulos') {
          <div class="pdf-btn-row">
            <button mat-button (click)="openPdfSelect()">
              <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512" style="height: 20px; vertical-align: middle">
                <path d="M320 336h76c55 0 100-21.21 100-75.6s-53-73.47-96-75.6C391.11 99.74 329 48 256 48c-69 0-113.44 45.79-128 91.2-60 5.7-112 35.88-112 98.4S70 336 136 336h56M192 400.1l64 63.9 64-63.9M256 224v224.03" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" />
              </svg>
              {{ 'raportit.lataa-pdf' | translate | async }}
            </button>
            <div class="hidden-select">
              <mat-select #pdfSelect>
                @for (pdf of pdfList(); track pdf) {
                  <mat-option (click)="downloadPdf(pdf.type, pdf.kieli)">
                    {{ pdf.tag }}
                  </mat-option>
                }
              </mat-select>
            </div>
          </div>
        }
        @if (!tila.eiTilikausia && selectedTab() === 'lyhyt-tase-ja-tulos') {
          <div app-kirjanpito-virallinen-tase [hakuvaihtoehdotObservable]="hakuvaihtoehdotObservable" class="raportti-container"></div>
        }
        @if (!tila.eiTilikausia && selectedTab() === 'lyhyt-tase-ja-tulos') {
          <div app-kirjanpito-virallinen-tulos [hakuvaihtoehdotObservable]="hakuvaihtoehdotObservable" class="raportti-container" style="margin-top: 6em"></div>
        }
      </mat-tab>
      <!-- <mat-tab [label]="'raportit.paakirja' | translate | async">
        @if (!tila.eiTilikausia && selectedTab() === 'paakirja') {
          <div app-kirjanpito-paakirja [hakuvaihtoehdotObservable]="hakuvaihtoehdotObservable" class="raportti-container"></div>
        }
      </mat-tab> -->
      <mat-tab [label]="'raportit.brutto-tuloslaskelma' | translate | async">
        @if (!tila.eiTilikausia && selectedTab() === 'bruttotuloslaskelma') {
          <div class="pdf-btn-row">
            <button mat-button (click)="openPdfSelect()">
              <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512" style="height: 20px; vertical-align: middle">
                <path d="M320 336h76c55 0 100-21.21 100-75.6s-53-73.47-96-75.6C391.11 99.74 329 48 256 48c-69 0-113.44 45.79-128 91.2-60 5.7-112 35.88-112 98.4S70 336 136 336h56M192 400.1l64 63.9 64-63.9M256 224v224.03" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" />
              </svg>
              {{ 'raportit.lataa-pdf' | translate | async }}
            </button>
            <div class="hidden-select">
              <mat-select #pdfSelect>
                @for (pdf of pdfList(); track pdf) {
                  <mat-option (click)="downloadPdf(pdf.type, pdf.kieli)">
                    {{ pdf.tag }}
                  </mat-option>
                }
              </mat-select>
            </div>
          </div>
        }
        @if (!tila.eiTilikausia && selectedTab() === 'bruttotuloslaskelma') {
          <div app-kirjanpito-bruttotuloslaskelma [hakuvaihtoehdotObservable]="hakuvaihtoehdotObservable" class="raportti-container"></div>
        }
      </mat-tab>
    </mat-tab-group>
    @if (tila.eiTilikausia) {
      <div>
        <div class="ei-raportteja">{{ 'raportit.ei-raportteja' | translate | async }}.</div>
      </div>
    }
  </div>
}
